import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=5ccc7666&scoped=true"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"
import style1 from "./Email.vue?vue&type=style&index=1&id=5ccc7666&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccc7666",
  null
  
)

export default component.exports